module.exports = {
  checkArgsType: require('./src/check-args-type'),
  checkArguments: require('./src/check-arguments'),
};
